export default __webpack_public_path__ + "static/virginradio-logo.1869fb36.svg";